// 261010 P8b-1 — các màn trạng thái (dời nguyên JSX từ FilmWorkflowPage).
import React from 'react';
import { ReloadOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import { workflowErrorKind, workflowErrorText } from './workflowBoardUtils';

export const WorkflowLoading: React.FC<{ top: React.ReactNode }> = ({ top }) => (
  <div className="wf" aria-busy="true">{top}
    <div className="wf-skel wf-skel-hero" style={{ marginBottom: 12 }} />
    <div className="wf-skel wf-skel-steps" style={{ marginBottom: 12 }} />
    <div className="wf-grid" style={{ marginBottom: 12 }}>
      <div className="wf-skel wf-skel-card" /><div className="wf-skel wf-skel-card" /><div className="wf-skel wf-skel-card" />
    </div>
    <div style={{ textAlign: 'center', padding: 16 }}><Spin /> <span className="muted">Đang tải trạng thái plan…</span></div>
  </div>
);

export const WorkflowLoadError: React.FC<{
  top: React.ReactNode;
  error: any;
  onRetry: () => void;
  onOpenLegacy: () => void;
  onOpenPlans: () => void;
}> = ({ top, error, onRetry, onOpenLegacy, onOpenPlans }) => {
  const kind = workflowErrorKind(error);
  return (
    <div className="wf">{top}
      <div className="wf-state" role="alert">
        <h2>{kind === 'NOT_SKY_PLAN' ? 'Plan không dùng luồng mới' : kind === 'NOT_FOUND' ? 'Không tìm thấy plan' : 'Không tải được'}</h2>
        <p className="muted" style={{ margin: 0, maxWidth: 520 }}>{workflowErrorText(error)}</p>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', justifyContent: 'center' }}>
          {kind === 'NOT_SKY_PLAN' && <button type="button" className="wf-btn primary" onClick={onOpenLegacy}>Mở UI cũ</button>}
          {(kind === 'NETWORK' || kind === 'OTHER') && <button type="button" className="wf-btn primary" onClick={onRetry}><ReloadOutlined /> Thử lại</button>}
          <button type="button" className="wf-btn" onClick={onOpenPlans}>← Về danh sách plan</button>
        </div>
      </div>
    </div>
  );
};

export const WorkflowEmptyPlan: React.FC<{ top: React.ReactNode; onOpenLegacy: () => void }> = ({ top, onOpenLegacy }) => (
  <div className="wf">{top}
    <div className="wf-state"><h2>Plan chưa có video nào</h2>
      <p className="muted" style={{ margin: 0 }}>Plan này chưa được chia video. Tạo/chia video ở UI cũ rồi quay lại đây.</p>
      <button type="button" className="wf-btn primary" onClick={onOpenLegacy}>Mở UI cũ</button></div>
  </div>
);

export const WorkflowEventMissing: React.FC<{ top: React.ReactNode; onBackToBoard: () => void }> = ({ top, onBackToBoard }) => (
  <div className="wf">{top}
    <div className="wf-state" role="alert"><h2>Không tìm thấy video này trong plan</h2>
      <p className="muted" style={{ margin: 0 }}>Đường dẫn có thể đã cũ (video đã bị gộp/xoá).</p>
      <button type="button" className="wf-btn primary" onClick={onBackToBoard}>← Về bảng</button></div>
  </div>
);
